import { Link, NavLink } from 'react-router-dom'
import './index.scss'
import LogoS from '../../assets/images/logo-s.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload, faEnvelope, faFile, faHome, faImages, faNoteSticky, faUser } from '@fortawesome/free-solid-svg-icons'
import { faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons'
import {  faBars } from '@fortawesome/free-solid-svg-icons'
import {  useState } from 'react'

const Sidebar = () => {

    const [showNav, setShowNav] = useState(false); //can see the menu when set to true// can see the hamburger icon when set to false 

    return (

        <div className="nav-bar">
       
            <nav className={showNav ? 'mobile-show' : ''}> 
                <NavLink exact="true" activeclassname="active" to="/">
                    <FontAwesomeIcon icon={faHome} color="#4d4d4e" />
                </NavLink>
                <NavLink exact="true" activeclassname="active" className="about-link" to="/about">
                    <FontAwesomeIcon icon={faUser} color="#4d4d4e" />
                </NavLink>
                <NavLink exact="true" activeclassname="active" className="portfolio-link" to="/portfolio">
                    <FontAwesomeIcon icon={faImages} color="#4d4d4e" />
                </NavLink>
                <NavLink exact="true" activeclassname="active" className="contact-link" to="/contact">
                    <FontAwesomeIcon icon={faEnvelope} color="#4d4d4e" />
                </NavLink>   
            </nav>

        <ul>
            <li>
                <a 
                target="_blank"
                rel='noreferrer'
                href ="https://www.linkedin.com/in/karidouglas/">
                    <FontAwesomeIcon icon={faLinkedin} color="#4d4d4e" />
                </a>
            </li>
            <li>
                <a target="_blank"
                rel='noreferrer'
                href ="https://github.com/kouglas">
                    <FontAwesomeIcon icon={faGithub} color="#4d4d4e" />
                </a>
            </li>
            <li>
                <a target="_blank"
                rel='noreferrer'
                href ="https://docs.google.com/document/d/1VE6xQHJV2WJsEGYUnz9SMB3fXYO5c4bHgvNM0IUjz3U/edit?usp=sharing">
                    <FontAwesomeIcon icon={faFile} color="#4d4d4e" />
                </a>
            </li>
            

        </ul>


        <FontAwesomeIcon 
          onClick={() => setShowNav(true)}
          icon={faBars}
          color="#AD7DE3"
          size="2x"
          className='hamburger-icon' />
    </div>
)

}

export default Sidebar